export default __webpack_public_path__ + "static/media/29-Watch-Out-For-Skimmers.5bed9ffe.jpg";